import React, { useState } from "react";
import TextLinks from "../../components/TextLinks";

function Faq(params) {
    if (window.origin.includes('localhost')) {
        console.log('Faq')
        console.log(params)
    }

    let colorBack = ''
    if (params.block['en']['FontColor'] !== '' && params.block['en'].hasOwnProperty('FontColor')) {
        colorBack = 'b-' + params.block['en']['FontColor']
    }
    let innerSection = 'accordion container';
    let innerContainer = 'container-wide';
    if (params.block['en']['InnerBackground'] !== '') {
        innerSection = innerSection + ' ' + colorBack;
    }

    const Accordion = ({ title, children, id }) => {
        const [isOpen, setOpen] = useState(false);
        const buttonId = `accordion-button-${id}`;
        const regionId = `accordion-region-${id}`;
        return (
            <div className="accordion-wrapper mb-20">
                <h3 className={`accordion-title d-flex jc-between ai-center ${isOpen ? "open" : ""}`}>
                    <button
                        tabindex="0"
                        id={buttonId}
                        className="d-flex jc-between ai-center"
                        aria-expanded={isOpen}
                        aria-controls={regionId}
                        onClick={() => setOpen(!isOpen)}
                    >
                        <span>{title}</span>
                        <i className={`arrow ${isOpen ? "up" : "down"}`} aria-hidden="true"></i>
                    </button>
                </h3>
                <div
                    id={regionId}
                    role="region"
                    aria-labelledby={buttonId}
                    hidden={!isOpen}
                    className={`accordion-item ${!isOpen ? "collapsed" : ""}`}
                >
                    <div className="accordion-content text">
                        <TextLinks text={children} line={params.line} />
                    </div>
                </div>
            </div>
        );
    };
    
    const accordionValues = [];
    accordionValues.push(params.block['en']['Item']);
    
    return (
        <section className={innerSection}>
            <div className="wrapper">
                <div className={innerContainer}>
                    <h2>{params.block['en']['Title']}</h2>
                    {accordionValues.map((item, i) => {
                        return item.map((item, j) => {
                            return (
                                <Accordion
                                    title={item.AccordionQuestion}
                                    key={`accordion-item-${i}-${j}`}
                                    id={`${i}-${j}`}
                                >
                                    {item.AccordionAnswer}
                                </Accordion>
                            )
                        })
                    })}
                </div>
            </div>
        </section>
    );
}

export default Faq;